var isObject = require('../internals/is-object');

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/internals/an-object.js